<template>
    <div>
        <div  v-for="(bulletin,bulletinIndex) in homeContent" :key="bulletin.id">
            <div :class="bulletinIndex==0 && index===0?'container-fluid p-0 cm-game-background':'container-fluid p-0 mt-3 cm-game-background'"
                :style="item.htmlStyle"
                v-for="(item,index) in bulletin" :key="item.id">
                <div v-if="bulletinIndex==0 && index===0 && !ismore" class="cm-game-showgame">
                    {{$t('homecontent.HomeBar')}}
                </div>

                <div class="offset-6 col-6">
                    <div class="cm-game-box">
                        <div class="cm-game-logo" ></div>
                        <div class="cm-game-title-container">
                            <svg class="cm-game-title-svg-chrome" viewBox="0 0 600 100">
                                <foreignObject width="100%" height="100%">
                                    <div class="cm-game-title-svg-div-chrome" :style="{color:item.gameTitleColor}">
                                        {{item.gameTitle}}
                                    </div>
                                </foreignObject>
                            </svg>
                        </div>
                        <div class="cm-game-intro-container">
                            <svg class="cm-game-intro-svg-chrome" viewBox="0 0 600 100">
                                <foreignObject width="100%" height="100%">
                                    <div class="cm-game-intro-svg-div-chrome" :style="{color:item.gameIntroColor}">
                                        {{item.gameIntro}}
                                    </div>
                                </foreignObject>
                            </svg>
                        </div>
                        <div class=" cm-game-icon">
                            <a :href="item.googleplayUrl" v-show="item.googleplayUrl!=''" class="cm-game-android" style="background-size: 90%;" target="_blank" alt="googleplay"></a>
                            <a :href="item.appstoreUrl" v-show="item.appstoreUrl!=''" class="cm-game-ios" style="background-size: 90%;" target="_blank" alt="applestore"></a>
                            <a :href="item.apkUrl" v-show="item.apkUrl!=''" class="cm-game-apk" style="background-size: 90%;" target="_blank" alt="apkdownload"></a>
                            <a :href="item.fbUrl" v-show="item.fbUrl!=''" class="cm-game-facebook" style="background-size: 90%;" target="_blank" alt="facebook"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {cm_title_container_dynamic_height,cm_game_svg_initial} from '@/assets/js/cm-game'
import UserAgentUtil from "@/assets/js/util/UserAgentUtil.js";

export default {
    data() {
        return {
            banners: [],
            homeContent: [],
            HomeInfo:{},
            userAgentInfo: UserAgentUtil.parseUserAgent(navigator.userAgent)
        };
    },
    watch: {
        content(val)
        {
            this.HomeInfo = val;
            this.getHomeInfo();
        }
    },
    methods: {
        getHomeInfo()
        {
            var Result = this.HomeInfo.data;
            var data = [];
            this.homeContent = [];
            
            if(Result!=undefined && Result.result!=undefined && Result.result == "success")
            {
                var ContentData = Result.data;
                if(!this.ismore)
                {
                    for(let i=0; i<ContentData.moreIndex && i<ContentData.bulletin.length; i++)
                    {
                        data.push(this.setHomeInfo(i,ContentData));
                    }
                }
                else
                {
                    for(let i= ContentData.moreIndex; i<ContentData.bulletin.length; i++)
                    {
                        data.push(this.setHomeInfo(i,ContentData));
                    }
                }

                if(data.length>0)
                {
                    for(let i=0; i<data.length; i+=2)
                    {
                        if(i+1<data.length)
                        {
                            this.homeContent.push([data[i],data[i+1]]);
                        }
                        else
                        {
                            this.homeContent.push([data[i]]);
                        }
                    }
                }
            }
            this.$nextTick(function () {
                cm_title_container_dynamic_height();
                cm_game_svg_initial(); // 首頁頁面遊戲介紹的title初始化
            });
        },
        setHomeInfo(i,ContentData)
        {
            let jsonContent = {};
            let bulletin;
            jsonContent = {};
            bulletin = ContentData.bulletin[i];
            jsonContent.gameImage = bulletin.imgHost + bulletin.imgPath + bulletin.imgFileName;
            jsonContent.htmlStyle = "background: url("+jsonContent.gameImage+") 0% 0% / 100% no-repeat";
            jsonContent.gameName = bulletin.content.GameName;
            jsonContent.gameTitle = bulletin.title;
            jsonContent.gameTitleColor = bulletin.content.gameTitleColor;
            jsonContent.gameIntroColor = bulletin.content.gameIntroColor;
            jsonContent.gameIntro = bulletin.content.GameContent;
            jsonContent.appstoreUrl = bulletin.content.GameAppStoreUrl;
            jsonContent.googleplayUrl = bulletin.content.GameAndroidUrl;
            jsonContent.apkUrl = bulletin.content.GameThirdUrl;
            jsonContent.fbUrl = bulletin.content.GameFbUrl;
            if(this.userAgentInfo.operatingSystemName == UserAgentUtil.OS.Android) {
                jsonContent.appstoreUrl = "";
            }
            else if(this.userAgentInfo.operatingSystemName == UserAgentUtil.OS.iOS) {
                jsonContent.googleplayUrl = "";
                jsonContent.apkUrl = "";
            }

            let customizeList = [];
            let customizeJson = {};
            for(let index=1; ; index++)
            {
                if(bulletin.content["GameCustomizeTitle"+index])
                {
                    customizeJson.title = bulletin.content["GameCustomizeTitle"+index];
                    customizeJson.content = bulletin.content["GameCustomizeContent"+index];
                    //若不使用此"深copy"方式，則會push記憶體位址而非值(淺copy)
                    customizeList.push(Object.assign({}, customizeJson));
                }
                else
                {
                    break;
                }
            }
            if(customizeList.length > 0)
            {
                jsonContent.customizeList = customizeList;
            }
            
            return jsonContent;
        },
        handleResize() {
            // 首頁頁面中遊戲介紹的圖片title動態調整高度
            cm_title_container_dynamic_height();
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
    },
    props: ['ismore','content']
}
</script>